'use strict'

import React from 'react'
import Logo  from './logo'
import Menu  from './menu'

class Header extends React.Component {
  constructor () {
    super()

    this.state = {
      hideMenu: false
    }

    window.hideMenu = ((hide) => {
      this.setState({
        hideMenu: hide
      })
    }).bind(this)
  }

  render () {
    return (
      <div className='header full-width container'>
        <a className={this.props.firstForm && !this.props.introPage ? 'quotePage' : ''} href='/voucher-signup/index.html'>
          <Logo />
        </a>
        <div className='information'>
        </div>
        {(this.props.introPage ||
          this.props.findPage ||
          (!this.props.introPage && !this.props.findPage && !this.props.firstForm)) && (
          <div>
            <div className='nav'>
              {!this.state.hideMenu &&
                <Menu
                  startForm={this.props.startForm}
                  startQuote={this.props.startQuote}
                  startFind={this.props.startFind}
                  />
              }
            </div>

            <div className='nav--desktop'>
              <ul>
                <li onClick={this.props.startForm}><a>Buy a Voucher & Save</a></li>
                <li className="desktop-hidden"><a href="/contact">Contact DMA</a></li>
                <li className="desktop-hidden"><a href="/about-dma/dental-packages-faqs">FAQs</a></li>
                <li><a href="/dentist" className="login-button">Log In</a></li>
              </ul>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/assets/header.js